import { render, staticRenderFns } from "./DesktopPlanTableRow.vue?vue&type=template&id=8d82a95c"
import script from "./DesktopPlanTableRow.vue?vue&type=script&lang=js"
export * from "./DesktopPlanTableRow.vue?vue&type=script&lang=js"
import style0 from "./DesktopPlanTableRow.vue?vue&type=style&index=0&id=8d82a95c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports